// extracted by css-extract-rspack-plugin
export default {"wrapper":"OrdReportUploadField-module__wrapper--WOsKa"};